<template>
  <div>
    <a-form-model layout="vertical" @submit.prevent="login()">
      <a-form-model-item label="Correo electrónico">
        <a-input
          placeholder="Ingrese su correo electrónico"
          autocomplete="username"
          v-model="email"
          ref="email"
        />
      </a-form-model-item>
      <a-form-model-item label="Contraseña">
        <a-input-password
          placeholder="Ingrese su contraseña"
          autocomplete="current-password"
          v-model="password"
        />
        <div
          class="mt-2 text-left text-sm flex flex-col justify-center items-center sm:flex-row sm:justify-between"
        >
          <!-- <span class="my-1 flex justifycenter items-center text-xs"
            ><input type="checkbox" id="remember" class="mr-2 rounded" />
            Recordarme</span
          > -->
          <!-- <router-link to="/recovery" class="my-1 text-blue text-xs"
            ><b>¿Olvidó su contraseña?</b></router-link
          > -->

          <a
            href="#"
            class="my-1 text-blue-dark text-sm w-full text-right"
            @click.prevent="openAccountRecoveryModal"
            ><b>¿Olvidé mi contraseña?</b></a
          >
        </div>
      </a-form-model-item>
      <a-form-model-item v-if="feedback">
        <p class="text-sm text-red-500">{{ feedback }}</p>
      </a-form-model-item>
      <a-form-model-item>
        <a-button
          type="primary"
          html-type="submit"
          shape="round"           
          :loading="loading"
          :disabled="!email || !password"
        >
          <span class="w-32 mx-auto text-sm text-center">Iniciar sesión</span>
        </a-button>
      </a-form-model-item>
      <ModalInactivateResponse
        :visible="showModal"
        :group_flag="groupFlag"
        @toggle-modal="toggleModal"
      />
      <Modal v-if="showModalRecaptchaEnterprise" size="md">
        <div class="text-center">
          <p class="mt-4" v-html="modalText"></p>
          <button
            @click="closeModalRecaptcha"
            class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
          >
            ACEPTAR
          </button>
        </div>
      </Modal>
    </a-form-model>

    <!-- Perdida de acceso al teléfono -->
    <!-- Modal para Restablecer Google Authenticator -->
    <ModalComponent
      :visible="showResetGa"
      :handleOk="handleResetGa"
      :handleCancel="handleCancelReset"
      :showResendCode="false"
      :modalProps="modalProps"
      :cancelButtonText="'CANCELAR'"
      :okButtonText="'ACEPTAR'"
    >
      <h3 class="text-blue-700 text-2xl my-4">
        Restablecer el acceso mediante código QR
      </h3>
      <p class="mb-4">
        Al restablecer la configuración de autenticación mediante código QR, se
        reemplazará la configuración actual de la autenticación en dos pasos.
        Esta acción solo debe realizarse si has perdido el acceso a tu
        dispositivo anterior o estás cambiando a uno nuevo.
      </p>

      <div class="flex justify-center">
        <qrcode-vue :value="otpAuthUrl" :size="150" :level="'M'"></qrcode-vue>
      </div>

      <p class="mt-4 mb-0">
        Una vez que se haya escaneado el código, por favor hacer clic en Aceptar
        para continuar el proceso de configuración.
      </p>

      <div v-if="feedbackError">
        <p class="mt-3 mb-2 text-sm text-left text-red-500">
          {{ feedbackError }}
        </p>
      </div>
    </ModalComponent>

    <!-- Usuarios existentes -->
    <!-- Modal para Habilitar el acceso mediante código QR - Usuario con correo electrónico -->
    <ModalComponent
      :visible="showEnableGaEmail"
      :handleOk="handleEnableGaEmail"
      :handleCancel="handleOmit"
      :showResendCode="false"
      :modalProps="modalProps"
      :okButtonText="'ACEPTAR'"
      :cancelButtonText="'OMITIR'"
    >
      <h3 class="text-blue-700 text-2xl my-4">
        Habilitar el acceso mediante código QR
      </h3>
      <p class="text-justify mb-4">
        Para reforzar la seguridad, se requerirá la autenticación en dos pasos
        (2FA) mediante aplicaciones como Google Authenticator, Microsoft
        Authenticator, Oracle Mobile Authenticator u otras compatibles que
        generen códigos a través del escaneo de un código QR. Al activar esta
        opción, se solicitará un código generado por la aplicación cada vez que
        se inicie sesión.
      </p>

      <div class="flex justify-center">
        <qrcode-vue :value="otpAuthUrl" :size="150" :level="'M'"></qrcode-vue>
      </div>

      <p class="mt-4 mb-0">
        Una vez que se haya escaneado el código, por favor hacer clic en Aceptar
        para continuar el proceso de configuración.
      </p>

      <div v-if="feedbackError">
        <p class="mt-3 mb-2 text-sm text-left text-red-500">
          {{ feedbackError }}
        </p>
      </div>
    </ModalComponent>

    <!-- Modal para Habilitar el acceso mediante código QR - Usuarios sin correo electrónico -->
    <ModalComponent
      :visible="showEnableGaNotEmail"
      :handleOk="handleEnableGaNotEmail"
      :handleCancel="handleCancel"
      :showResendCode="false"
      :modalProps="modalProps"
      :okButtonText="'ACEPTAR'"
    >
      <h3 class="text-blue-700 text-2xl my-4">
        Habilitar el acceso mediante código QR
      </h3>
      <p class="text-justify mb-4">
        Para reforzar la seguridad, se requerirá la autenticación en dos pasos
        (2FA) mediante aplicaciones como Google Authenticator, Microsoft
        Authenticator, Oracle Mobile Authenticator u otras compatibles que
        generen códigos a través del escaneo de un código QR. Al activar esta
        opción, se solicitará un código generado por la aplicación cada vez que
        se inicie sesión.
      </p>

      <div class="flex justify-center">
        <qrcode-vue :value="otpAuthUrl" :size="150" :level="'M'"></qrcode-vue>
      </div>

      <p class="mt-4 mb-0">
        Una vez que se haya escaneado el código, por favor hacer clic en Aceptar
        para continuar el proceso de configuración.
      </p>

      <div v-if="feedbackError">
        <p class="mt-3 mb-2 text-sm text-left text-red-500">
          {{ feedbackError }}
        </p>
      </div>
    </ModalComponent>

    <!-- Modal para ingresar código de confirmación -->
    <ModalComponent
      :visible="showConfirmationCode"
      :handleOk="handleConfirmationCode"
      :handleCancel="handleCancelConfirmationCode"
      :showResendCode="false"
      :modalProps="modalProps"
    >
      <h3 class="text-blue-700 text-2xl my-4">Código de confirmación</h3>
      <p class="text-justify mb-3">
        Abra la aplicación de autenticación (como Google Authenticator,
        Microsoft Authenticator, Oracle Mobile Authenticator u otra similar) con
        la que escaneó el código QR e ingrese el código de seis dígitos
        generado.
      </p>

      <div class="grid gap-5 grid-cols-1 mb-2">
        <BaseInput
          ref="verificateCode"
          name="verificateCode"
          label="Código de confirmación"
          v-model="form.verificationCode"
          required="true"
          type="text"
          maxlength="6"
        />
      </div>

      <div v-if="feedbackError">
        <p class="mt-3 mb-2 text-sm text-left text-red-500">
          {{ feedbackError }}
        </p>
      </div>
    </ModalComponent>

    <!-- Doble factor de autenticación-->
    <!-- Modal seleccionar modo de doble autenticación | correo - google authenticator. -->
    <ModalComponent
      :visible="showMailOrGa"
      :handleOk="handleOk"
      :handleCancel="handleCancel"
      :showResendCode="false"
      :modalProps="modalProps"
      :showOkButton="false"
    >
      <h3 class="text-blue-700 text-2xl my-4">Doble factor de autenticación</h3>

      <div class="w-full flex flex-wrap justify-center gap-5 mt-5">
        <div
          class="mail flex flex-col items-center cursor-pointer mr-2"
          role="button"
          @click="twoFactorMail"
        >
          <a-icon
            type="mail"
            class="text-gray-500"
            :style="{
              fontSize: '70px',
              padding: '2rem',
              border: '1px solid gray',
              borderRadius: '7px',
            }"
          />
          <span
            class="text-sm font-medium fw-medium mt-2 text-gray-500 text-center"
            >Correo <br />
            electrónico</span
          >
        </div>
        <div
          class="phone flex flex-col items-center cursor-pointer ml-2"
          role="button"
          @click="twoFactorGA"
        >
          <img
            src="@/assets/icons/qr-code.svg"
            alt="Codigo QR"
            class="text-gray-500"
            :style="{
              width: '135.6x',
              height: '135.6px',
              padding: '2rem',
              border: '1px solid gray',
              borderRadius: '7px',
              objectFit: 'contain',
            }"
          />
          <span
            class="text-sm font-medium fw-medium mt-2 text-gray-500 text-center"
            >Código QR</span
          >
        </div>
      </div>

      <div v-if="feedbackMailOrGa">
        <p class="mt-4 mb-2 text-sm text-center text-red-500">
          {{ feedbackMailOrGa }}
        </p>
      </div>
    </ModalComponent>

    <!-- Modal confirma código vía email. -->
    <ModalComponent
      :visible="showMail"
      :handleOk="handleAuthCodeMail"
      :handleCancel="handleCancelAuthCode"
      :showResendCode="true"
      :handleResendCode="handleResendCodeEmail"
      :modalProps="modalProps"
    >
      <h3 class="text-blue-700 text-2xl my-4">
        Ingresa el código de autorización
      </h3>
      <p class="mb-3">
        Hemos enviado un código de autorización al correo
        {{ form.email }}
      </p>

      <input
        v-model="verificationCode"
        name="verificationCode"
        class="w-full rounded-lg border-gray-400"
        type="number"
        placeholder="Ingrese el código para continuar"
      />

      <div v-if="feedbackAuthCode">
        <p class="mt-3 mb-0 text-sm text-left text-red-500">
          {{ feedbackAuthCode }}
        </p>
      </div>
    </ModalComponent>

    <!-- Modal para ingresar código de autorización  por medio de Google Authenticator-->
    <ModalComponent
      :visible="showAuthCodeQr"
      :handleOk="handleAuthCodeQr"
      :handleCancel="handleCancelAuthCode"
      :showResendCode="false"
      :modalProps="modalProps"
    >
      <h3 class="text-blue-700 text-2xl my-4">Código de autorización</h3>
      <p class="text-justify mb-3">
        Abra la aplicación de autenticación (como Google Authenticator,
        Microsoft Authenticator, Oracle Mobile Authenticator u otra similar) con
        la que escaneó el código QR e ingrese el código de seis dígitos
        generado.
      </p>

      <div class="grid gap-5 grid-cols-1 mb-2">
        <BaseInput
          ref="verificateCode"
          name="verificateCode"
          label="Código de autorización"
          v-model="form.verificationCode"
          required="true"
          type="text"
          maxlength="6"
        />
      </div>

      <div class="mt-4">
        <a
          href="#"
          class="text-blue text-xs"
          @click.prevent="resetGoogleAuthenticator"
        >
          <b>¿Ha perdido acceso al teléfono?</b>
        </a>
      </div>

      <div v-if="feedbackAuthCode">
        <p class="mt-3 mb-2 text-sm text-left text-red-500">
          {{ feedbackAuthCode }}
        </p>
      </div>
    </ModalComponent>

    <!-- ¿Olvidó su contraseña? -->
    <!-- Modal seleccionar método de recuperación de cuenta | Correo electrónico - Soporte técnico -->
    <ModalComponent
      :visible="showSelectAccountRecovery"
      :handleOk="handleOk"
      :handleCancel="handleCancel"
      :showResendCode="false"
      :modalProps="modalProps"
      :showOkButton="false"
    >
      <h3 class="text-blue-700 text-2xl my-4">¿Olvidó su contraseña?</h3>

      <div class="w-full flex flex-wrap justify-center gap-5 mt-5">
        <div
          class="mail flex flex-col items-center cursor-pointer mr-2"
          role="button"
          @click="recoverEmailAccount"
        >
          <a-icon
            type="mail"
            class="text-gray-500"
            :style="{
              fontSize: '70px',
              padding: '2rem',
              border: '1px solid gray',
              borderRadius: '7px',
            }"
          />
          <span
            class="text-sm font-medium fw-medium mt-2 text-gray-500 text-center"
            >Correo <br />
            electrónico</span
          >
        </div>
        <div
          class="phone flex flex-col items-center cursor-pointer ml-2"
          role="button"
          @click="recoverTechnicalSupport"
        >
          <img
            src="@/assets/icons/customer-service.svg"
            alt="Technical support"
            class="text-gray-500"
            :style="{
              width: '135.6x',
              height: '135.6px',
              padding: '2rem',
              border: '1px solid gray',
              borderRadius: '7px',
              objectFit: 'contain',
            }"
          />
          <span
            class="text-sm font-medium fw-medium mt-2 text-gray-500 text-center"
            >Soporte<br />
            técnico</span
          >
        </div>
      </div>
    </ModalComponent>

    <!-- Modal para establecer el tipo de problema de soporte -->
    <ModalComponent
      :visible="showTypeTechnicalSupport"
      :handleOk="handleTechnicalSupportOk"
      :handleCancel="handleCancel"
      :showResendCode="false"
      :modalProps="modalProps"
      :okButtonText="'ACEPTAR'"
    >
      <h3 class="text-blue-700 text-2xl my-4">Soporte técnico</h3>
      <p class="mb-3">Seleccione el tipo de problema que presenta:</p>

      <div class="grid gap-5 grid-cols-1 mb-2">
        <label class="flex items-center cursor-pointer mb-0">
          <input
            type="radio"
            name="supportType"
            value="email"
            v-model="technicalSupportType"
            class="mr-3"
          />
          No puedo acceder a mi correo electrónico
        </label>
        <label class="flex items-center cursor-pointer">
          <input
            type="radio"
            name="supportType"
            value="identification"
            v-model="technicalSupportType"
            class="mr-3"
          />
          Mi número de identificación es incorrecto o no puedo realizar el
          registro con el numero de identificación
        </label>
      </div>
      <div v-if="feedbackTechnicalSupport">
        <p class="mt-4 mb-2 text-sm text-left text-red-500">
          {{ feedbackTechnicalSupport }}
        </p>
      </div>
    </ModalComponent>

    <Modal v-if="showModalAccessFront" size="md">
      <div class="text-center">
        <p class="mt-4" v-html="modalTextAccessFront"></p>
        <button
          @click="closeAccessFront"
          class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
        >
          ACEPTAR
        </button>
      </div>
    </Modal>
  </div>
</template>
<script>
import ModalInactivateResponse from "./ModalInactivateResponse.vue";
import Modal from "@/components/UI/Modal.vue";
import {
  ACTION_LOGIN,
  CORRECT_PASSWORD,
  MSG_ERROR_RECAPTCHA,
} from "../../core/utils/constants.js";
import recaptchaEnterpriseClient from "../../core/data/network/client/recaptcha_enterprise_client.js";
import ModalComponent from "../UI/ModalComponent.vue";
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    Modal,
    ModalInactivateResponse,
    ModalComponent,
    QrcodeVue,
  },
  data() {
    return {
      assessmentId: "",
      email: "",
      password: "",
      feedback: "",
      feedbackError: "",
      loading: false,
      modalText: MSG_ERROR_RECAPTCHA,
      showModal: false,
      showModalRecaptchaEnterprise: false,
      groupFlag: false,
      userData: {},
      isMailOrGa: false,
      showMailOrGa: false,
      showMail: false,
      feedbackAuthCode: "",
      feedbackMailOrGa: "",
      feedbackTechnicalSupport: "",
      modalProps: {
        disabledOkButton: false,
      },
      form: {
        email: "",
        verificationCode: "",
      },
      otpAuthUrl: "",
      showConfirmationCode: false,
      showAuthCodeQr: false,
      showEnableGaEmail: false,
      showEnableGaNotEmail: false,
      showResetGa: false,
      showSelectAccountRecovery: false,
      showTypeTechnicalSupport: false,
      technicalSupportType: "",
      user_id: "",
      userResetGa: false,
      userNotEmail: false,
      verificationCode: "",
      modalTextAccessFront: false,
      showModalAccessFront: false,
    };
  },
  mounted() {
    this.$refs.email.$el.focus();
  },
  methods: {
    resetRecaptcha() {
      this.assessmentId = "";
      this.showModalRecaptchaEnterprise = false;
      this.loading = false;
    },
    closeModalRecaptcha() {
      this.showModalRecaptchaEnterprise = false;
      this.resetRecaptcha();
    },
    closeAccessFront() {
      this.showModalAccessFront = false;
      window.location.reload();
    },
    async login() {
      this.loading = true;
      grecaptcha.enterprise.ready(async () => {
        const siteKey = process.env.VUE_APP_SK_RECAPTCHA;
        const siteKeyType = "score";
        const tokenUser = await grecaptcha.enterprise.execute(`${siteKey}`, {
          action: `${ACTION_LOGIN}`,
        });
        const userAction = {
          event: {
            token: tokenUser,
            expectedAction: ACTION_LOGIN,
            typeSiteKey: siteKeyType,
          },
        };

        let responseCreateAssessment =
          await recaptchaEnterpriseClient.createAssessment(userAction);
        if (responseCreateAssessment.data.valid === false) {
          this.showModalRecaptchaEnterprise = true;
          return;
        }

        if (
          responseCreateAssessment.data.score > process.env.VUE_APP_MIN_SCORE &&
          responseCreateAssessment.data.score < process.env.VUE_APP_MAX_SCORE
        ) {
          this.showModalRecaptchaEnterprise = true;
          return;
        }

        this.assessmentId = responseCreateAssessment.data.assessment_id;
        this.preLogin();
      });
    },
    async preLogin() {
      const credentials = {
        email: this.email?.toLowerCase().trim(),
        password: this.password,
      };
      this.$store
        .dispatch("session/preLogin", credentials)
        .then(async (res) => {
          this.loading = false;
          this.userData = JSON.parse(JSON.stringify(res.data));

          if (!this.userData.is_active) {
            if (this.userData.id_company?.id === 1) {
              this.groupFlag = !this.userData.group_state;
              this.showModal = true;
            } else {
              this.redirectToVerifyCode();
            }
          } else {
            // Pero el rol se encuentra inactivo igual no se deja iniciar sesión.
            if (
              this.userData.id_company?.id === 1 &&
              !this.userData?.group_state
            ) {
              this.groupFlag = !this.userData.group_state;
              this.showModal = true;
              return;
            }

            if (
              process.env.VUE_APP_DIS_2FA &&
              process.env.VUE_APP_DIS_2FA === "true"
            ) {
              this.loginUser();
              return;
            }

            if (this.userData?.bypass) {
              this.loginUser();
              return;
            }

            if (this.userData.enable_qr !== null) {
              await this.redirectToTwoFactor();
            } else {
              // Flujo de actualización de información para usuarios existentes
              this.existingUsers();
            }
          }
        })
        .catch((error) => {
          if (error?.status_code === 429 && Array.isArray(error.errors)) {
            this.feedback =
              error.errors[1] ||
              "Demasiados intentos de inicio de sesión. Intente más tarde.";
            this.loading = false;
            return;
          }
          if (error.errors) {
            this.feedback = error.errors[0];
          }
          this.loading = false;
        });
    },
    async loginUser() {
      this.$store
        .dispatch("session/login", {
          email: this.email?.toLowerCase().trim(),
          password: this.password,
        })
        .then(async (res) => {
          if (res === undefined) {
            throw "Error en inicio de sesión";
          }

          const haveNotShowFront = res.groups.filter(
            (item) => item.show_front === false,
          ).length;

          if (haveNotShowFront > 0) {
            this.$store.dispatch("session/logout").then(() => {
              this.modalTextAccessFront =
                "El usuario no tiene habilitado el acceso para navegar en el front de SmartSupervision. Su uso está limitado exclusivamente al consumo de servicios REST API.";
              this.showModalAccessFront = true;
            });
            return;
          }

          // Anotación de una evaluación
          const userAnotate = {
            assessment_id: this.assessmentId,
            expected_annotate: CORRECT_PASSWORD,
          };

          await recaptchaEnterpriseClient.anotateAssessment(userAnotate);
          if (this.$route.query.procedimiento && this.$route.query.tipo) {
            let urlToRedirect = "/";
            urlToRedirect = this.cfUrlRedirection();
            this.$router.push(urlToRedirect).catch(() => {});
            return;
          }

          this.$router.push("/").catch(() => {});
        })
        .catch((error) => {
          if (error?.status_code) {
            if (error.status_code === 429) {
              this.feedback = error.detail;
            }
          } else if (error?.error === "Los datos no coinciden") {
            this.feedback = "Usuario y/o contraseña no son válidos";
          } else if (error?.error) {
            this.feedback = error.error;
          } else {
            this.feedback = "Error con el servidor, intente más tarde.";
          }
          this.loading = false;
        });
    },
    checkForm() {
      let validation = false;
      if (
        !this.$validator.isEmail(this.email) ||
        this.$validator.isEmpty(this.password)
      ) {
        this.feedback = "Verifique la información";
      } else {
        this.feedback = "";
        validation = true;
      }
      return validation;
    },
    toggleModal(value) {
      this.showModal = value;
    },
    async existingUsers() {
      const respGenerateQrCode = await this.generateQrCode();
      if (respGenerateQrCode.validQrGen) {
        this.otpAuthUrl = respGenerateQrCode.otpAuthUrl;
        this.user_id = respGenerateQrCode.user_id;
      } else {
        this.feedback = respGenerateQrCode.feedback;
        return;
      }
      if (this.userData.email && this.userData.email !== "") {
        // Flujo de habilitación de Google Authenticator para usuarios existentes que tienen correo
        this.feedbackError = "";
        this.showEnableGaEmail = true;
      } else {
        // Flujo de habilitacion de Google Authenticator para usuarios existentes que NO tienen correo
        this.feedbackError = "";
        this.showEnableGaNotEmail = true;
      }
    },

    async generateQrCode() {
      let response = {};
      const credentials = {
        username: this.email?.toLowerCase().trim(),
        password: this.password,
      };

      const { data, error } = await this.$api.generateQrMfa(credentials);

      if (error) {
        if (error?.status_code === 401) {
          response.feedback = "Usuario y/o contraseña no son válidos";
          response.validQrGen = false;
          return response;
        }

        if (error?.status_code === 429) {
          response.feedback = error.detail;
          response.validQrGen = false;
          return response;
        }

        response.feedback = error.error;
        response.validQrGen = false;
        return response;
      }
      if (data) {
        response.otpAuthUrl = data.otp_auth_url;
        response.user_id = data.user_id;
        // response.showEnableGaEmail = true;
        response.validQrGen = true;
      } else {
        response.feedback = "Error al generar el código QR";
        response.validQrGen = false;
      }
      return response;
    },

    async handleConfirmationCode() {
      const credentials = {
        username: this.email?.toLowerCase().trim(),
        password: this.password,
        otp: this.form.verificationCode,
      };

      const { data, error } = await this.$api.confirmQrMfa(credentials);

      if (error) {
        if (error?.status_code === 401) {
          return (this.feedbackError = "Usuario y/o contraseña no son válidos");
        }

        return (this.feedbackError = error.detail);
      }
      if (data) {
        this.showConfirmationCode = false;
        await this.loginUser();
      } else {
        this.feedbackError = "Error al validar el código de confirmación";
      }
    },

    async handleCancelConfirmationCode() {
      if (this.userResetGa) {
        this.showConfirmationCode = false;
        await this.redirectToTwoFactor();
        return;
      }

      if (this.userNotEmail) {
        this.handleCancel();
        return;
      }

      const credentials = {
        username: this.email?.toLowerCase().trim(),
        password: this.password,
        enable: false,
      };

      const { data, error } = await this.$api.modifyEnableQr(credentials);

      if (error) {
        if (error?.status_code === 401) {
          return (this.feedbackError = "Usuario y/o contraseña no son válidos");
        }

        if (error?.status_code === 429) {
          return (this.feedbackError = error.detail);
        }

        return (this.feedbackError =
          "Error al generar el modificar el estado del código de confirmación qr");
      }
      if (data) {
        this.showConfirmationCode = false;
        await this.redirectToTwoFactor();
      } else {
        this.feedbackError =
          "Error al generar el modificar el estado del código de confirmación qr";
      }
    },
    async handleAuthCodeQr() {
      const credentials = {
        username: this.email?.toLowerCase().trim(),
        password: this.password,
        otp: this.form.verificationCode,
      };

      const { data, error } = await this.$api.authQrMfa(credentials);

      if (error) {
        if (error?.status_code === 401) {
          return (this.feedbackAuthCode =
            "Usuario y/o contraseña no son válidos");
        }

        return (this.feedbackAuthCode = error.detail);
      }
      if (data) {
        this.showAuthCodeQr = false;
        await this.loginUser();
      } else {
        this.feedbackAuthCode = "Error al validar el código de autorización";
      }
    },
    async resetGoogleAuthenticator() {
      const respGenerateQrCode = await this.generateQrCode();
      if (respGenerateQrCode.validQrGen) {
        this.otpAuthUrl = respGenerateQrCode.otpAuthUrl;
        this.user_id = respGenerateQrCode.user_id;
      } else {
        this.feedbackAuthCode = respGenerateQrCode.feedback;
        return;
      }
      this.feedbackError = "";
      this.showAuthCodeQr = false;
      this.showResetGa = true;
    },
    handleCancel() {
      window.location.reload();
    },
    handleCancelAuthCode() {
      this.showMail = false;
      this.showAuthCodeQr = false;

      // Retornar al componente de selección de tipo de 2FA
      if (this.isMailOrGa) {
        this.feedbackMailOrGa = "";
        this.showMailOrGa = true;
      } else {
        // Reiniciar el proceso de inicio de sesión
        this.handleCancel();
      }
    },
    async handleOk() {},
    async handleResendCodeEmail() {
      this.feedbackAuthCode = "";
      this.verificationCode = "";

      const credentials = {
        username: this.email?.toLowerCase().trim(),
        password: this.password,
      };
      const { data, error } = await this.$api.generateMailCode(credentials);

      if (error) {
        if (error?.status_code === 401) {
          return (this.feedbackAuthCode =
            "Usuario y/o contraseña no son válidos");
        } else {
          this.feedbackAuthCode = error.error;
        }
      }
      if (data) {
        this.user_id = data.user_id;
      }
    },
    async handleAuthCodeMail() {
      if (!this.verificationCode) {
        this.feedbackAuthCode = "Todos los campos son obligatorios";
        return;
      }

      if (this.verificationCode && this.user_id) {
        const { data, error } = await this.$api.verifyMailCode({
          otp: this.verificationCode,
          user_id: this.user_id,
        });
        if (error) {
          return (this.feedbackAuthCode = error.error);
        }
        if (data) {
          this.loginUser();
        }
      }
    },
    async twoFactorMail() {
      this.feedbackAuthCode = "";
      this.form.verificationCode = "";
      this.verificationCode = "";

      const credentials = {
        username: this.email?.toLowerCase().trim(),
        password: this.password,
      };
      const { data, error } = await this.$api.generateMailCode(credentials);

      if (error) {
        if (error?.status_code === 401) {
          return (this.feedbackMailOrGa =
            "Usuario y/o contraseña no son válidos");
        } else {
          this.feedbackMailOrGa = error.error;
        }
      }
      if (data) {
        this.user_id = data.user_id;
        this.showMailOrGa = false;
        this.verificationCode = "";
        this.feedbackAuthCode = "";
        this.showMail = true;
      }
    },
    async twoFactorGA() {
      this.showMailOrGa = false;
      this.form.verificationCode = "";
      this.verificationCode = "";
      this.feedbackAuthCode = "";
      this.showAuthCodeQr = true;
    },
    async redirectToVerifyCode() {
      this.$store
        .dispatch("session/login", {
          email: this.email.toLowerCase(),
          password: this.password,
        })
        .then(async () => {
          this.$router.push({ name: "Verify" });
        });
    },
    handleEnableGaEmail() {
      this.showEnableGaEmail = false;
      this.showEnableGaNotEmail = false;
      this.form.verificationCode = "";
      this.verificationCode = "";
      this.feedbackError = "";
      this.showConfirmationCode = true;
    },
    handleEnableGaNotEmail() {
      this.userNotEmail = true;
      this.showEnableGaEmail = false;
      this.showEnableGaNotEmail = false;
      this.form.verificationCode = "";
      this.feedbackError = "";
      this.showConfirmationCode = true;
    },
    handleResetGa() {
      this.userResetGa = true;
      this.showResetGa = false;
      this.form.verificationCode = "";
      this.feedbackError = "";
      this.showConfirmationCode = true;
    },
    async handleCancelReset() {
      this.showResetGa = false;
      await this.redirectToTwoFactor();
      return;
    },
    async handleOmit() {
      const credentials = {
        username: this.email?.toLowerCase().trim(),
        password: this.password,
        enable: false,
      };

      const { data, error } = await this.$api.modifyEnableQr(credentials);

      if (error) {
        if (error?.status_code === 401) {
          return (this.feedbackError = "Usuario y/o contraseña no son válidos");
        }

        if (error?.status_code === 429) {
          return (this.feedbackError = error.detail);
        }

        return (this.feedbackError =
          "Error al generar el modificar el estado del código de confirmación qr");
      }
      if (data) {
        this.showEnableGaEmail = false;
        await this.redirectToTwoFactor();
      } else {
        this.feedbackError =
          "Error al generar el modificar el estado del código de confirmación qr";
      }
    },
    async redirectToTwoFactor() {
      // Flujo de doble factor de autenticacion
      this.form.email = this.userData.email;

      if (
        this.userData.email &&
        this.userData.email !== "" &&
        this.userData.enable_qr
      ) {
        // Flujo donde el usuario puede seleccionar el doble factor de autenticación que utilizara
        this.isMailOrGa = true;
        this.feedbackMailOrGa = "";
        this.showMailOrGa = true;
      } else if (this.userData.email && this.userData.email !== "") {
        // Flujo donde el usuario unicamente puede realizar el doble factor de autenticación por medio de correo
        this.feedbackAuthCode = "";
        this.verificationCode = "";
        this.isMailOrGa = false;

        const credentials = {
          username: this.email?.toLowerCase().trim(),
          password: this.password,
        };
        const { data, error } = await this.$api.generateMailCode(credentials);

        if (error) {
          if (error?.status_code === 401) {
            return (this.feedback = "Usuario y/o contraseña no son válidos");
          } else {
            this.feedback = error.error;
          }
        }
        if (data) {
          this.user_id = data.user_id;
          this.verificationCode = "";
          this.feedbackAuthCode = "";
          this.showMail = true;
        }
      } else {
        // Flujo donde el usuario unicamente puede realizar el doble factor de autenticación por google authenticator
        this.isMailOrGa = false;
        this.verificationCode = "";
        this.feedbackAuthCode = "";
        this.showAuthCodeQr = true;
      }
    },
    // Métodos para funcionalidad de Olvidó su contraseña
    handleTechnicalSupportOk() {
      if (!this.technicalSupportType) {
        this.feedbackTechnicalSupport = "Debe seleccionar un tipo de problema";
        return;
      }

      if (this.technicalSupportType === "email") {
        // this.feedbackTechnicalSupport =
        //   "Ha seleccionado el problema de correo electrónico.";
        this.$router.push("/technical-support?type=email").catch(() => {});
      } else if (this.technicalSupportType === "identification") {
        // this.feedbackTechnicalSupport =
        //   "Ha seleccionado el problema de número de identificación.";
        this.$router
          .push("/technical-support?type=identification")
          .catch(() => {});
      } else {
        this.feedbackTechnicalSupport = "Tipo de soporte no reconocido.";
        return;
      }
      // Aquí puedes usar this.technicalSupportType para saber la opción seleccionada
      // Ejemplo:
      // if (this.technicalSupportType === 'problema_acceso') { ... }
      // else if (this.technicalSupportType === 'problema_funcionalidad') { ... }
      // Por ahora solo lo mostramos en consola:
      console.log("Tipo de soporte seleccionado:", this.technicalSupportType);
      // Cierra el modal o realiza la acción necesaria
      // this.showTypeTechnicalSupport = false;
      // this.feedbackTechnicalSupport = "";
    },
    openAccountRecoveryModal() {
      this.showSelectAccountRecovery = true;
    },
    recoverEmailAccount() {
      this.showSelectAccountRecovery = false;
      this.$router.push("/recovery").catch(() => {});
    },
    recoverTechnicalSupport() {
      this.showSelectAccountRecovery = false;
      this.showTypeTechnicalSupport = true;
    },
    cfUrlRedirection() {
      let urlToRedirect = "/";
      if (this.$route.query.procedimiento && this.$route.query.tipo) {
        const procedimiento = this.$route.query.procedimiento;
        const tipo = this.$route.query.tipo;
        const valor = this.$route.query.valor ? this.$route.query.valor : "";
        switch (procedimiento) {
          case "radicacion":
            switch (tipo) {               
              case "queja":
                urlToRedirect = `/customer/complaint/registration`;
                break;
              case "conciliacion":
              case "demanda":
                urlToRedirect = `/customer/complaint/registration?tipo=${tipo}`;
                break;
              default:
                urlToRedirect = "/";
                break;
            }
            break;
          case "complaint-agiliza-cf":
            switch (tipo) {
              case "cierre-queja":
                urlToRedirect = `/customer/complaint/tracking/detail/${valor}?type=agiliza`;
                break;
              case "confirm":
                urlToRedirect = `/customer/complaint-agiliza/confirm/${valor}`;
                break;
              case "programacion-sesion":
              case "reprogramacion-sesion":
                urlToRedirect = `/customer/complaint/tracking/detail/${valor}?type=agiliza&action=sesion`;
                break;
              case "revision-propuesta":
                urlToRedirect = `/customer/complaint/tracking/detail/${valor}?type=agiliza&action=contrapropuesta`;
                break;
              default:
                urlToRedirect = "/";
                break;
            }
            break;
          case "complaint-agiliza-ev":
            switch (tipo) {
              case "cierre-queja":
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza`;
                break;
              case "contrapropuesta":
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=contrapropuesta`;
                break;
              case "programacion-sesion":
              case "reprogramacion-sesion":
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=sesion`;
                break;
              case "reporte-incumplimiento-facilitacion":              
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=reporte-incumplimiento-facilitacion`;
                break;
              default:
                urlToRedirect = "/";
                break;
            }
            break;

          case "complaint-agiliza-sfc":
            switch (tipo) {
              case "programacion-sesion":
              case "reprogramacion-sesion":
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=sesion`;
                break;
              default:
                urlToRedirect = "/";
                break;
            }
            break;

          default:
            urlToRedirect = "/";
            break;
        }
      } else {
        urlToRedirect = "/";
      }
      return urlToRedirect;
    },
  },
  watch: {
    technicalSupportType() {
      this.feedbackTechnicalSupport = "";
    },
  },
};
</script>
